import { SET_TRAINING_COURSE } from "../actions/trainingActions";


const defaultState = {
    trainingCourses: []
}

export const trainingReducer = (state = defaultState, action: any) => {
    const { type, data } = action;
    if (type === SET_TRAINING_COURSE) return { ...state, trainingCourses: data };
    return state;
}